export default __webpack_public_path__ + "static/media/icon-rank-star-green.8d0a88e0.svg";